import { render, staticRenderFns } from "./UrunListesiDuzenle.vue?vue&type=template&id=d2aafeb6&"
import script from "./UrunListesiDuzenle.vue?vue&type=script&lang=js&"
export * from "./UrunListesiDuzenle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports